import React, { Component } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { observer } from 'mobx-react'

import Input from '../../../form/Input'

@observer
class Mergefield extends Component {
    render() {
        const { store } = this.props
        const {
            onBlur,
            register,
            unregister,
            customTag,
        } = store

        return (
            <fieldset id="mergefield">
                <legend>Mergefield</legend>
                <Input
                    key="mergefieldName"
                    name="name"
                    label={i18n.t('customTag.edit.name')}
                    path={['config', 'mergefield']}
                    subHeading={i18n.t('customTag.mergefield.subheading')}
                    isMandatory
                    register={register}
                    unregister={unregister}
                    defaultValue={R.pathOr(null, ['config', 'mergefield'], customTag)}
                    onBlur={(obj) => onBlur(obj, null, null, ['config', 'mergefield'])}
                />
            </fieldset>
        )
    }
}

export default Mergefield
